import { SelectFilter } from '@agro-club/agroclub-shared'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

type Props = {
  value: string
  updateFilterState: (value: Record<string, string>) => void
}

export const StatusFilter: FC<Props> = ({ value, updateFilterState }) => {
  const { t } = useTranslation(['dashboard', 'company'])

  const options = [
    { label: t('company:small'), value: 'small' },
    { label: t('company:large'), value: 'large' },
  ]

  return (
    <SelectFilter
      placeholder={t('status')}
      options={options}
      onChange={(company_size) => updateFilterState({ company_size })}
      value={value}
      showSearch={false}
    />
  )
}
